export enum MatchType {
    gender = 'gender',
    language = 'lang',
    favorite = 'is_favorite',
    call = 'call',
    ml = 'ml'
}

export enum StreamStatus {
    SdpReceived = 'SdpReceived',
    SocketOpened = 'SocketOpened',
    PeerConnectionEstablished = 'PeerConnectionEstablished',
    Error = 'error',
    BrowserNotSupported = 'CodecError',
    PageHidden = 'PageHidden',
    Disconnected = 'disconnected',
}

export enum StreamProvider {
    StripChat = 'stripChat',
    CloudFlare = 'cloudflare',
    CloudFlareCalls = 'cloudflare-calls',
    IvsRealTime = 'ivs-realtime',
    Unknown = 'unknown',
    None = 'none',
}

export enum StreamingType {
    Broadcast = 'broadcast',
    Delivery = 'delivery',
}

export enum PlayerStatus {
    PeerConnectionEstablished = 'PeerConnectionEstablished',
    SocketOpened = 'SocketOpened',
    Error = 'error',
    CanPlay = 'canplay',
    BrowserNotSupported = 'CodecError'
}

export enum RoomUserConnectionStatus {
    Connected = 'connected',
    Reconnecting = 'reconnecting',
    ReconnectingTimeout = 'reconnectingTimeout',
    LeftTheRoom = 'leftTheRoom',
}
